import { render, staticRenderFns } from "./widget10.vue?vue&type=template&id=98eca0c0&scoped=true&"
import script from "./widget10.vue?vue&type=script&lang=js&"
export * from "./widget10.vue?vue&type=script&lang=js&"
import style0 from "./widget10.vue?vue&type=style&index=0&id=98eca0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eca0c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VProgressCircular,VRow,VTooltip})
